import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-4 py-5 sm:px-4 flex justify-between items-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-center space-x-3" }
const _hoisted_5 = { class: "text-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "0", -1)
const _hoisted_7 = { class: "text-gray-500 text-sm" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lenders_filter = _resolveComponent("lenders-filter")!
  const _component_ShieldCheckIcon = _resolveComponent("ShieldCheckIcon")!
  const _component_base_rating = _resolveComponent("base-rating")!
  const _component_BanIcon = _resolveComponent("BanIcon")!
  const _component_data_table = _resolveComponent("data-table")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_pagination = _resolveComponent("base-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_lenders_filter, {
            key: 0,
            scope: "matching"
          }))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_data_table, {
          key: 0,
          tableData: _ctx.originators,
          tableHeader: _ctx.tableHeader,
          minHeight: true
        }, {
          "cell-name": _withCtx(({ row: originator }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["font-medium text-gray-900 cursor-pointer", { 'opacity-50': originator.deleted }]),
              onClick: ($event: any) => (_ctx.showProfile(originator.id))
            }, _toDisplayString(originator.name), 11, _hoisted_2)
          ]),
          "cell-lender": _withCtx(({ row: originator }) => [
            _createElementVNode("span", {
              class: "text-sky cursor-pointer",
              onClick: ($event: any) => (_ctx.showLender(originator.lenderId))
            }, _toDisplayString(originator.lenderName), 9, _hoisted_3)
          ]),
          "cell-overview": _withCtx(({ row: match }) => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ShieldCheckIcon, {
                class: _normalizeClass(["w-4 h-4", {
              'text-blue-500': match.isVerified,
              'text-gray-300': !match.isVerified
            }])
              }, null, 8, ["class"]),
              (match.rating)
                ? (_openBlock(), _createBlock(_component_base_rating, {
                    key: 0,
                    rating: match.rating
                  }, null, 8, ["rating"]))
                : _createCommentVNode("", true),
              (match.deleted)
                ? (_openBlock(), _createBlock(_component_BanIcon, {
                    key: 1,
                    class: "w-4 h-4 text-red-700"
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          "cell-location": _withCtx(({ row: match }) => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(match.city || '–') + ", " + _toDisplayString(match.stateProvince || '–'), 1)
          ]),
          "cell-stats": _withCtx(() => [
            _hoisted_6
          ]),
          "cell-activity": _withCtx(({ row: originator }) => [
            _createElementVNode("span", _hoisted_7, _toDisplayString(originator.lastLogin ? `Last login ${_ctx.moment(originator.lastLogin)}` : 'N/a'), 1)
          ]),
          "cell-products": _withCtx(({ row: originator }) => [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(originator.creditBoxes, (product, index) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: index,
                  class: "py-1 px-2.5 rounded-full mr-2 text-xs bg-blue-200 text-sky cursor-pointer",
                  onClick: ($event: any) => (_ctx.showProfile(originator.id))
                }, _toDisplayString(product.name), 9, _hoisted_9))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["tableData", "tableHeader"]))
      : (_openBlock(), _createBlock(_component_base_spinner, {
          key: 1,
          class: "h-80"
        })),
    _createVNode(_component_base_pagination, {
      pagingData: _ctx.paging,
      onCurrentChange: _ctx.onPageChange
    }, null, 8, ["pagingData", "onCurrentChange"])
  ]))
}